import React, {useState} from 'react'
import { Link , NavLink, useLocation} from 'react-router-dom'
import Logo from "../assets/images/brandlogo.png"
import {AiOutlineMenu} from "react-icons/ai"
import {HashLink} from "react-router-hash-link"

const NavBar = () => {

  const isLocation = useLocation()
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <nav className="text-black shadow-xl bg-white w-full z-20">
        <div className="container mx-auto py-1 lg:px-6 px-6 flex justify-between items-center">
          <div className="space-x-10 flex items-center">
            <Link to="/" className="text-2xl">
              <img src={Logo} alt="" className="w-20" />
            </Link>
          </div>

          {isLocation?.pathname.includes("catalogue") ? (
            <div className="space-x-10 items-center hidden lg:flex ">
              <NavLink to="/" className="text-md lg:text-xl">
                Home
              </NavLink>
              <HashLink to="#contact" className="text-md lg:text-xl">
                Contact
              </HashLink>
            </div>
          ) : (
            <div className="space-x-10 items-center hidden lg:flex ">
              <NavLink to="/" className="text-md lg:text-xl">
                Home
              </NavLink>
              <HashLink to="#about" className="text-md lg:text-xl">
                About
              </HashLink>
              <HashLink to="#services" className="text-md lg:text-xl">
                Services
              </HashLink>
              <HashLink to="#contact" className="text-md lg:text-xl">
                Contact
              </HashLink>
            </div>
          )}

          {/* Mobile Navbar MenuBar */}
          <button
            className="text-2xl text-black z-50 lg:hidden"
            onClick={() => {
              isOpen ? setIsOpen(false) : setIsOpen(true);
            }}
          >
            <AiOutlineMenu />
          </button>
        </div>
      </nav>

      {/* Mobile Navbar */}
      <nav
        className={`absolute bg-white py-10 rounded-b-2xl top-[86px] lg:hidden right-0 ${
          !isOpen && `hidden`
        } w-full shadow-xl z-30 transition-all duration-500`}
      >
        {isLocation.pathname.includes("catalogue") ? (
          <div className="flex flex-col justify-center space-y-10 items-center px-4">
            <NavLink to="/" className="text-md lg:text-xl">
              Home
            </NavLink>
            <HashLink to="#contact" className="text-md lg:text-xl">
              Contact
            </HashLink>
          </div>
        ) : (
          <div className="flex flex-col justify-center space-y-10 items-center px-4">
            <NavLink to="/" className="text-md lg:text-xl">
              Home
            </NavLink>
            <HashLink to="#about" className="text-md lg:text-xl">
              About
            </HashLink>
            <HashLink to="#services" className="text-md lg:text-xl">
              Services
            </HashLink>
            <HashLink to="#contact" className="text-md lg:text-xl">
              Contact
            </HashLink>
          </div>
        )}
      </nav>
    </>
  );
}

export default NavBar